import { parseKvpsWholesalerAndBrand } from "@/lib/kvps";
import type { getLemaSalesPersonsRequestSchema } from "@/lib/schemas/cat/lema-sales-persons-request";
import type { z } from "zod";

export type LemaSalesPersonsQueryParams = Partial<
  z.infer<typeof getLemaSalesPersonsRequestSchema>
>;

/** Maps a vehicle KVPS identifier to LEMA seller API query filters. */
export function getLemaSalesPersonsQueryParamsFromKvpsIdentifier(
  identifier: string | null | undefined,
): LemaSalesPersonsQueryParams {
  const filter = parseKvpsWholesalerAndBrand(identifier);
  if (!filter) return {};

  return {
    wholesalerNumber: filter.wholesalerNumber,
    brandLetter: filter.brandLetter,
  };
}

export function isLemaSalesPersonsFilterActive(
  params: LemaSalesPersonsQueryParams,
): boolean {
  return Boolean(params.wholesalerNumber && params.brandLetter);
}
